<template>
  <div>
    <div class="slide mb-5">
      <div class="bg-img">
        <div class="slide-content">
          <h2 class="slide-header">{{ 'Purchase requests' }}</h2>
          <div>
            <h5 class="slide-h5">{{ $t('message.home') }}</h5>
            <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider"></b-icon>
            <h5 class="slide-h5">{{ 'Purchase requests' }}</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-5">
      <b-row>
        <b-col cols="6" class="d-flex align-items-center mb-3">
          <h3 class="filter-text">{{ $t('message.filter') }}</h3>
          <b-form-input v-model="searchQuery" placeholder="Search for an order..." class="filter-input"></b-form-input>
        </b-col>
        <b-col cols="6" class="d-flex align-items-center justify-content-end mb-3">
          <h3 class="filter-text">{{ 'Select status' }}</h3>
          <v-select v-model="selectedStatus" :options="statusOptions" label="text" @input="fetchData"
            class="filter-input"></v-select>
        </b-col>
      </b-row>

      <!-- جدول الطلبات -->
      <b-table :items="filteredOrders" hover responsive class="custom-body mb-3" :fields="fields"
        @row-clicked="showOrderDetails">


        <template #cell(technical)="data">
          <b-badge style="border-radius: 6px; padding: 5px; width: 50px;" variant="info">
            {{ data.item.technical }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-button v-if="!showPrintBtn" size="sm store-action-btn" @click="approveOrder(data.item.id)">✅</b-button>
          <b-button v-if="!showPrintBtn" size="sm" class="ml-2 store-action-btn"
            @click="openRejectModal(data.item)">❌</b-button>
          <b-button v-if="showPrintBtn" size="sm" class="ml-2 store-action-btn printInvoice btn-success"
            @click="printInvoice(data.item)">🖨 Print</b-button>
        </template>
      </b-table>

      <!-- تفاصيل الطلب -->
      <b-modal size="xl" id="orderDetailsModal" title="Order Details" class="custom-modal">
        <div class="modal-content-custom">
          <!-- Order Info -->
          <b-list-group class="order-info" col="12">
            <b-list-group-item><strong> <b-icon class="order-icon" icon="person"> </b-icon> Responsible:</strong> {{
              selectedOrder.name }}</b-list-group-item>
            <b-list-group-item><strong><b-icon class="order-icon" icon="phone"> </b-icon>Phone:</strong> {{
              selectedOrder.phone }}</b-list-group-item>
          </b-list-group>

          <!-- Items Table -->
          <h5 class="mt-3 mb-3 section-title">Items</h5>
          <!-- {{ this.selectedOrders }} -->
          <div v-if="isAnySelected && !selectAll" class="mb-3">
            <b-button variant="success" class="rounded-btn mr-2" @click="approveOrder1()">Accept</b-button>
            <b-button variant="danger" class="rounded-btn" @click="openRejectModal1()">Reject</b-button>

          </div>
          <b-table :items="selectedOrderDetails" :fields="fields1" small bordered responsive class="custom-table">
            <template #head(select)="data">
              <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"></b-form-checkbox>
            </template>
            <template #cell(select)="row">
              <b-form-checkbox v-model="row.item.selected"></b-form-checkbox>
            </template>
          </b-table>
        </div>

        <!-- Footer Buttons -->
        <template #modal-footer>
          <b-button variant="secondary" class="rounded-btn" @click="$bvModal.hide('orderDetailsModal')">Close</b-button>
          <b-button variant="success" class="rounded-btn" @click="approveOrder(selectedOrder.id)">Accept</b-button>
          <b-button variant="danger" class="rounded-btn" @click="openRejectModal(selectedOrder)">Reject</b-button>
        </template>
      </b-modal>

      <!-- تفاصيل الفتوره -->
      <b-modal scrollable size="xl" id="orderInvoiceModal" title="Order Details" class="custom-modal">
        

        <div ref="printSection" class="invoice-container">
        <b-card class="invoice-card p-4">
          <!-- Header -->
          <div class="invoice-header">
            <div class="company-info">
              <!-- <img src="@/assets/logo-medium.png" alt="Company Logo" class="company-logo"> -->
              <h2>{{this.company.companyName}}</h2>
              <!-- <p>123 Street, City, Country</p> -->
              <p>Phone: {{ this.company.companyPhone }}</p>
              <p>Email: {{ this.company.companyEmail }}</p>
            </div>
            <div class="invoice-details text-right">
              <h3>Purchase Order</h3>
              <p><strong>Date:</strong> {{ new Date().toLocaleDateString() }}</p>
              <p><strong>Invoice ID:</strong> {{ order.id }}</p>
            </div>
          </div>
  
  
          <hr>
  
          <!-- Order & Customer Details -->
          <b-row class="mt-4">
            
            <b-col md="12" class="customer-details">
              <h5 class="section-title">Customer Details</h5>
              <p><strong>Name:</strong> {{ order.customerName }}</p>
              <p><strong>Email:</strong> {{ order.customerEmail }}</p>
              <p><strong>Phone:</strong> {{ order.customerPhone }}</p>
            </b-col>
          </b-row>
  
          <hr>
  
          <!-- Table -->
          <b-table  responsive bordered class="invoice-table mt-4 custom-body" :items="inoviceItems" :fields="invoiceFields">
            <template #cell(quantityAvilableStore)="data">
              <span>{{ data.item.quantityAvilableStore }}</span>
              
            </template>
           
            
          </b-table>
  
  
          <!-- Total & Print Button -->
          <div class="text-right mt-4">
            <!-- <h4 class="total"><strong>Total: ${{ order.total }}</strong></h4> -->
            <b-button variant="success" class="print-btn mt-3" @click="print">🖨 Print PR</b-button>
            <!-- <b-button variant="primary" class="share-btn mt-3" @click="shareInvoice">📤 Share</b-button> -->
          </div>
        </b-card>
      </div>

        <!-- Footer Buttons -->
        <template #modal-footer>
          <b-button variant="secondary" class="rounded-btn" @click="$bvModal.hide('orderInvoiceModal')">Close</b-button>
          
        </template>
      </b-modal>



      <!-- رفض الطلب -->
      <b-modal id="rejectModal" title="Reject Order" @ok="rejectOrder" :ok-disabled="!rejectReason.trim()"
        class="custom-modal">
        <div class="modal-content-custom">
          <b-form-group label="Rejection Reason" class="custom-form-group">
            <b-form-textarea v-model="rejectReason" placeholder="Enter rejection reason"
              class="custom-textarea"></b-form-textarea>
          </b-form-group>
        </div>
      </b-modal>
      <b-modal id="reject-modal" title="Reject Orders" hide-footer>
        {{ selectedOrders }}
        <div v-for="(order, index) in selectedOrders" :key="order.itemId" class="mb-3">
          <b-form-group :label="'Rejection reason for Order Product ' + order.productType">
            <b-form-input v-model="rejectReasons[index]" required></b-form-input>
          </b-form-group>
        </div>
        <b-button variant="danger" class="rounded-btn" @click="rejectOrder1()">Confirm Rejection</b-button>
      </b-modal>


    </div>
  </div>
</template>

<script>
import axiosInstance from '../axios-config';
import { mapGetters } from 'vuex'
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    vSelect
  },
  data() {
    return {
      searchQuery: "",
      selectedStatus: { value: 0, text: "Pending" },
      orders: [

      ],
      statusOptions: [
        { value: 0, text: "Pending" },
        { value: 1, text: "Accepted" },
        { value: 2, text: "decline" }
      ],
      fields: [
        { key: "id", label: "Order id" },
        { key: "name", label: "Technical Responsible" },
        { key: "phone", label: "Phone" },
        { key: "actions", label: "Actions" },
      ],
      fields1: [
        { key: 'select', label: '', thStyle: { width: "1%" } },
        { key: 'itemId', label: 'Item ID' },
        { key: "itemDescEN", label: "Product" },
        { key: 'poiQuantity', label: 'POI Quantity' },
        { key: 'itemQty', label: 'Item Quantity' },
        { key: 'quantityAvilableStore', label: 'Available in Store' }
      ],
      selectedOrder: {},
      rejectReason: "",
      rejectReasons: [],
      selectedOrderDetails: [],
      currentPage: 1,
      perPage: 5,
      perPageOptions: [1, 2, 5, 10, 20, 50, 100],
      totalRows: 0,
      filter: '',
      selectAll: false,
      // invoice
      showPrintBtn: false,

      order: {
        id: "#123456",
        productType: "Laptop",
        quantity: 2,
        customerName: "John Doe",
        customerEmail: "johndoe@example.com",
        customerPhone: "123-456-7890",
        total: 1500,
      },
        
        company: {
          companyName: '',
          companyEmail: '',
          companyPhone: '',
  
        },
        inoviceItems: [],
        
        invoiceFields: [
          { key: "id", label: "Order ID" },
          { key: "itemId", label: "Item ID" },
          { key: "itemDescEN", label: "Product" },
          { key: "poiQuantity", label: "Required Quantity" },
          { key: "itemQty", label: "Available Quantity" },
          { key: "quantityAvilableStore", label: "Remaining Quantity" },
        //   { key: "actions", label: "Actions" },
        ],
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    company_id() {
      return this.getUser; // استخدام الـ getter لجلب بيانات المستخدم
    },
    isRTL() {
      return this.$i18n.locale === 'ar';
    },
    filteredOrders() {
      return this.orders.filter(order =>
      (order.name?.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        order.productType?.some(p => p.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
        order.technical?.toLowerCase().includes(this.searchQuery.toLowerCase()))
      );
    },
    selectedCount() {
      return this.selectedOrderDetails.filter(item => item.selected).length;
    },
    isAnySelected() {
      return this.selectedOrderDetails.some(item => item.selected);
    },
    selectedOrders() {
      return this.selectedOrderDetails
        .filter(item => item.selected)
        .map(item => ({
          itemId: item.id,
          comments: item.isDeleted ? "comments7" : " ",
          isDeleted: item.isDeleted ? 1 : 0,
          productType: item.itemDescEN,
        }));
    },

  },
  methods: {
    toggleSelectAll() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;

      this.selectedOrderDetails.slice(startIndex, endIndex).forEach(item => {
        item.selected = this.selectAll;
      });
    },

    async approveOrder(orderId) {
      try {
        const formData = new FormData();
        // formData.append('company_id', this.company_id.company_id);
        formData.append('po_id', orderId);
        formData.append('status', 2);
        formData.append('comments', '');

        const response = await axiosInstance.post('store/update_purchease_request.php', formData);

        if (response.data.status === "true") {
          this.orders = this.orders.filter(order => order.id !== orderId);
          this.$izitoast.success({
            title: "Success",
            message: "Order approved successfully ✅",
            position: "bottomLeft",
            timeout: 5000,
          });
          this.$bvModal.hide('orderDetailsModal'); // إغلاق المودال بعد التنفيذ
        } else {
          this.$izitoast.error({
            title: "Error",
            message: "Failed to approve order",
            position: "bottomLeft",
            timeout: 5000,
          });
        }
      } catch (error) {
        console.error('Error approving order:', error);
        this.$izitoast.error({
          title: "Error",
          message: "An error occurred while approving the order",
          position: "bottomLeft",
          timeout: 5000,
        });
      }
    },

    openRejectModal(order) {
      this.rejectReason = ""; // مسح سبب الرفض السابق
      this.selectedOrder = order; // تخزين الطلب المحدد
      this.$bvModal.show("rejectModal"); // فتح المودال
    },
    async rejectOrder() {
      if (!this.rejectReason.trim()) {
        this.$izitoast.error({
          title: "Failed",
          message: "Rejection reason is required!",
          position: "bottomLeft",
          timeout: 5000,
        });
        return;
      }

      try {
        const formData = new FormData();
        // formData.append('company_id', this.company_id.company_id);
        formData.append('po_id', this.selectedOrder.id);
        formData.append('status', 1);
        formData.append('comments', this.rejectReason);

        const response = await axiosInstance.post('store/update_purchease_request.php', formData);

        if (response.data.status === "true") {
          this.orders = this.orders.filter(order => order.id !== this.selectedOrder.id);
          this.$izitoast.error({
            title: "Rejected",
            message: "Order has been rejected ❌",
            position: "bottomLeft",
            timeout: 5000,
          });
          this.$bvModal.hide('rejectModal'); // إغلاق المودال بعد التنفيذ
          this.$bvModal.hide('orderDetailsModal'); // إغلاق المودال الرئيسي
        } else {
          this.$izitoast.error({
            title: "Error",
            message: "Failed to reject order",
            position: "bottomLeft",
            timeout: 5000,
          });
        }
      } catch (error) {
        console.error('Error rejecting order:', error);
        this.$izitoast.error({
          title: "Error",
          message: "An error occurred while rejecting the order",
          position: "bottomLeft",
          timeout: 5000,
        });
      }
    },

    async approveOrder1() {
      if (!this.selectedOrders.length) return;

      const payload = this.selectedOrders.map(order => ({
        ...order,
        isDeleted: 0, // Accepted
        comments: " " // لا يوجد تعليق في القبول
      }));

      try {
        const response = await axiosInstance.post('store/delete_parchease_request_item_amount.php', payload);
        console.log(response.data);

        this.$izitoast.success({
          title: "Success",
          message: "Orders accepted successfully ✅",
          position: "bottomLeft",
          timeout: 5000,
        });

        this.refreshTable();
      } catch (error) {
        console.error(error);
        this.$izitoast.error({
          title: "Error",
          message: "Failed to accept orders ❌",
          position: "bottomLeft",
          timeout: 5000,
        });
      }
    },

    openRejectModal1() {
      if (!this.selectedOrders.length) return;

      // إنشاء مصفوفة تحتوي على تعليقات فارغة بعدد الطلبات المحددة
      this.rejectReasons = this.selectedOrders.map(() => "");

      this.$bvModal.show("reject-modal");
    },

    async rejectOrder1() {
      // التأكد من أن جميع الحقول ممتلئة
      if (this.rejectReasons.some(reason => !reason.trim())) {
        this.$izitoast.error({
          title: "Failed",
          message: "All rejection reasons are required!",
          position: "bottomLeft",
          timeout: 5000,
        });
        return;
      }

      // تجهيز البيانات للإرسال بحيث يحتوي كل طلب على التعليق الخاص به
      const payload = this.selectedOrders.map((order, index) => ({
        itemId: order.itemId,
        isDeleted: 1, // تعني الرفض
        comments: this.rejectReasons[index] // تعيين السبب بناءً على الترتيب
      }));

      try {
        const response = await axiosInstance.post('store/delete_parchease_request_item_amount.php', payload, {
          headers: {
            'Content-Type': 'application/json', // التأكد من تحديد نوع المحتوى
          }
        });
        console.log(response.data);

        this.$izitoast.error({
          title: "Rejected",
          message: "Orders rejected successfully ❌",
          position: "bottomLeft",
          timeout: 5000,
        });

        this.refreshTable();
        this.$bvModal.hide("reject-modal");
      } catch (error) {
        console.error(error);
        this.$izitoast.error({
          title: "Error",
          message: "Failed to reject orders ❌",
          position: "bottomLeft",
          timeout: 5000,
        });
      }
    },


    refreshTable() {
      this.selectedOrderDetails.forEach(item => (item.selected = false));
      this.selectAll = false; // إعادة ضبط تحديد الكل
    },

    async fetchData() {
      try {
        const response = await axiosInstance.get('store/select_parchease_request.php', {
          params: {
            company_id: this.company_id.company_id,
            status: this.selectedStatus.value // إرسال الحالة المختارة إلى API
          }
        });
        console.log(1111111111);
        console.log(this.selectedStatus);

        if (this.selectedStatus.value == 1) {
          this.showPrintBtn = true;
        }


        console.log("Response Data:", response.data);
        if (response.data.status === "true") {
          this.orders = response.data.output; // التأكد من تحديث orders
        } else {
          this.orders = []; // لو مفيش بيانات، خليها فاضية
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        this.$izitoast.error({
          title: 'Error',
          message: 'An error occurred while trying to get data',
          position: 'bottomLeft',
          timeout: 5000,
        });
      }
    },

    async showOrderDetails(order) {
      if (!this.showPrintBtn) {
        try {
          this.selectedOrder = order; // حفظ البيانات الأساسية
          const response = await axiosInstance.get(`store/select_order_invoice_pr.php`, {
            params: {
              company_id: this.company_id.company_id,
              purchase_id: order.id
            }
          });

          if (response.data.status === "true") {
            this.selectedOrderDetails = response.data.output.items.map(item => ({
              ...item,
              selected: false
            }));
            this.$bvModal.show("orderDetailsModal"); // فتح المودال
          } else {
            this.$izitoast.error({
              title: 'Error',
              message: 'Failed to fetch order details',
              position: 'bottomLeft',
              timeout: 5000,
            });
          }
        } catch (error) {
          console.error('Error fetching order details:', error);
          this.$izitoast.error({
            title: 'Error',
            message: 'An error occurred while fetching order details',
            position: 'bottomLeft',
            timeout: 5000,
          });
        }
      } else {

      }

    },
    async printInvoice(order){
      try {
          this.selectedOrder = order; // حفظ البيانات الأساسية
          const response = await axiosInstance.get(`store/select_order_invoice_pr.php`, {
            params: {
              company_id: this.company_id.company_id,
              purchase_id: order.id
            }
          });

          if (response.data.status === "true") {
            this.inoviceItems = response.data.output.items.filter(item => item.itemStatus == 0);
            this.order.customerName = response.data.output.technical.name;
            this.order.customerEmail = response.data.output.technical.email;
            this.order.customerPhone = response.data.output.technical.phone;
            this.company.companyName = response.data.output.company.name;
            this.company.companyEmail = response.data.output.company.email;
            this.company.companyPhone = response.data.output.company.phone;
            this.$bvModal.show("orderInvoiceModal"); // فتح المودال
          } else {
            this.$izitoast.error({
              title: 'Error',
              message: 'Failed to fetch order details',
              position: 'bottomLeft',
              timeout: 5000,
            });
          }
        } catch (error) {
          console.error('Error fetching order details:', error);
          this.$izitoast.error({
            title: 'Error',
            message: 'An error occurred while fetching order details',
            position: 'bottomLeft',
            timeout: 5000,
          });
        }
    },
    print() {
    const content = this.$refs.printSection.innerHTML;
    const printWindow = window.open('', '', 'width=800,height=900');

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Invoice</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css">
          <style>
            body {
              padding: 20px;
              font-family: Arial, sans-serif;
            }
            .invoice-card {
              border: none;
              box-shadow: none;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${content}
        </body>
      </html>
    `);

    printWindow.document.close();
  }

  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.store-action-btn {
  background-color: transparent;
  border: 1px solid #2274BD;
  border-radius: 6px;
}

.store-action-btn:hover,
.store-action-btn:focus,
.store-action-btn:active {
  background-color: transparent !important;
  border: 1px solid #2274BD !important;
  box-shadow: none !important;
}

.printInvoice {
  background-color: #28a745 !important;
}

.printInvoice:hover,
.printInvoice:focus,
.printInvoice:active {
  background-color: #28a745 !important;
  border: 1px solid #2274BD !important;
  box-shadow: none !important;
}

.filter-input {
  border-radius: 6px;
  padding: 10px;
  border: 1px solid #2274BD;
  width: 260px;
}

.custom-modal .modal-content {
  border-radius: 10px !important;
  padding: 15px;
  background: #f8f9fa;
}

/* تحسين شكل المودال الداخلي */
.modal-content-custom {
  border-radius: 10px;
  background: #ffffff;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.order-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
  margin-bottom: 5px;
  font-size: 16px;
}

.order-info strong {
  color: #2274BD;
  font-size: 20px;
  font-weight: 500;
}

.order-info .order-icon {
  margin-right: 5px;
}

/* تحسين شكل القائمة */
.order-info .list-group-item {
  padding: 0.01rem 1.25rem !important;
  border: none !important;
}

/* تحسين شكل العناوين */
.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  border-bottom: 2px solid #007bff;
  padding-bottom: 5px;
  display: inline-block;
}

/* تحسين شكل الجدول */
.custom-table {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #ddd;
}

.custom-table th {
  background: #007bff;
  color: white;
  text-align: center;
}

.custom-table td {
  text-align: center;
}

/* تحسين الأزرار */
.rounded-btn {
  border-radius: 10px;
  padding: 8px 15px;
  font-size: 16px;
}

/* تحسين تصميم حقل الإدخال */
.custom-form-group label {
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.custom-textarea {
  border-radius: 10px;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 14px;
  min-height: 120px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease-in-out;
}

.custom-textarea:focus {
  border-color: #007bff;
  box-shadow: 0px 0px 8px rgba(0, 123, 255, 0.2);
}


</style>